import React from 'react';

// components
import { Modal } from 'antd';
import ButtonComponent from '../../elements/forms/ButtonComponent';
import { BiSearchAlt } from 'react-icons/bi';
import SearchInput from '../../elements/forms/SearchInput';

type ISingleSelect = {
	open: boolean;
	placeholder: string;
	children: React.ReactNode;
	search?: string;
	value: string;
	onShow: () => void;
	remove_proceed?: boolean;
	onSearch?: (search: string) => void;
};

const SingleSelect: React.FC<ISingleSelect> = ({
	open,
	search,
	placeholder,
	value,
	children,
	remove_proceed,
	onShow,
	onSearch
}) => {
	return (
		<>
			<div
				onClick={onShow}
				className="h-[60px] flex items-center border border-[#82828250] w-full hover:border-[#243677] rounded-lg bg-[white] cursor-pointer px-2 overflow-y-hidden overflow-x-scroll"
			>
				{value ? (
					<span className="bg-[#C3D0FF] px-2 py-1 rounded-sm mr-3">
						{value}
					</span>
				) : (
					<span className="text-[#797979D1]">{placeholder}</span>
				)}
			</div>

			<Modal
				open={open}
				footer={[]}
				closable={false}
				closeIcon={false}
				width="90%"
				bodyStyle={{ height: '90vh' }}
				centered
			>
				<div className="w-full flex justify-between mb-2 h-[10%]">
					<div className="w-[40%]">
						{search && (
							<SearchInput
								name="search"
								value={search}
								placeholder="Search..."
								icon={<BiSearchAlt size={18} color="#243677" />}
								onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
									onSearch?.(e.target.value)
								}
							/>
						)}
					</div>
					{!remove_proceed && (
						<div className="w-[30%] flex justify-end">
							<div className="w-[49%]">
								<ButtonComponent
									title="Proceed"
									onHandler={onShow}
									active={true}
								/>
							</div>
						</div>
					)}
				</div>
				<div className="w-full h-[90%] flex flex-col justify-between">
					{children}
				</div>
			</Modal>
		</>
	);
};

export default SingleSelect;
